import React, { useState, useEffect, useContext } from "react";
import { Dialog } from "primereact";

import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getInformacionEmpresa } from "../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { formatNumberDecimal } from "../../../Base/Services/FormatTemplate";

import pdfMake from "pdfmake/build/pdfmake";
import { getBoletaCompraPorDetID, getBoletaCompraPorEncID } from "../../../API/Finanzas/CajaChica/BoletaCompraRequest";
import { getFirmaPersonal } from "../../../API/Payrolls/Firmas/FirmasRequests";

const BoletaCompraReporte = ({ showDialogReporte, setShowDialogReporte, selected, setSelected }) => {

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [formato, setFormato] = useState([]);
  

  const getValoresIniciales = async (selected) => {
    setLoading(true);
    if(selected){
        const infoEmpresa = await getInformacionEmpresa()
        const encabezado = await getBoletaCompraPorEncID(selected?.IdBoletaCompraEnc)
        const detalles = await getBoletaCompraPorDetID(selected?.IdBoletaCompraEnc)
        const ImgBlanco = await getFirmaPersonal('111')

        const IdPersonalCreate = encabezado[0]?.IdPersonalCreate
        const IdPersonalRecibe = encabezado[0]?.IdPersonalRecibe
        let firmaCreate
        let firmaRecibe
        if(IdPersonalCreate){
            firmaCreate = await getFirmaPersonal(IdPersonalCreate)
        }
        if(IdPersonalRecibe && encabezado[0]?.IdStatus !== 119){
            firmaRecibe = await getFirmaPersonal(IdPersonalRecibe)
        }
        if(encabezado && detalles){
            GenerarFormato(encabezado[0], detalles, infoEmpresa[0], firmaCreate, firmaRecibe, ImgBlanco)
        }
    }
    setLoading(false);
  };

  const tablaLayout = {
    hLineWidth: function (i, node) {
      return i === 0 ? 0 : 0.25;
    },
    vLineWidth: function (i, node) {
      return 0.25;
    },
    hLineColor: function (i, node) {
      return "black"; 
    },
    vLineColor: function (i, node) {
      return "black"; 
    },
  };


  const GenerarFormato = (encabezado, detalles, infoEmpresa, firmaCreate, firmaRecibe, ImgBlanco) => {
    setLoading(true)
    const totalGeneral = detalles.reduce((acc, item) => acc + (item.TotalL || 0), 0);

    const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [40, 81, 40, 70],

        header: function (currentPage, pageCount, pageSize) {
            return {
                table: {
                    widths: ["29%", "41%", "30%"],
                    body: [
                        [
                            {
                                image: infoEmpresa?.LogoPrimarioB64,
                                width: 190,
                                rowSpan: 2,
                            },
                            {
                                text: infoEmpresa?.NombreLegal || "",
                                margin: [0, 30, 0, 0],
                                style: "titulo",
                            },
                            {
                                text: 'BOLETA DE COMPRA',
                                margin: [0, 30, 10, 0],
                                style: "titulo4",
                            },
                        ],
                        [
                            {},
                            {
                                text: infoEmpresa?.Direccion || "",
                                style: "titulo3",
                            },
                            {
                                text: encabezado?.NumeroBoletaCompra,
                                margin: [0, 0, 10, 0],
                                style: "titulo5",
                            },
                        ],
                    ],
                },
                layout: "noBorders",
            };
        },

        footer: (currentPage, pageCount) => {
            return {
                margin: [40, 15, 40, 0],
                table: {
                    widths: ['28%','*',],
                    body: [
                        [
                            {
                                text: 'Fecha Impresión: ' + new Date().toLocaleString('es-ES'),
                                style: 'footer',
                            },
                            {
                                text: `Pagina ${currentPage} / ${pageCount}`,
                                style: 'footerPag',
                            },
                        ],
                    ],
                },
                layout: {
                    defaultBorder: false,
                },
            };
        },

        content: [
            encabezado?.IdStatus === 119 ?
            {
                margin: [5,20,0,0],
                text: [
                    {
                        text: 'Boleta de Compra ',
                        style: 'enunciadoSimple'
                    },
                    {
                        text: `${encabezado.StatusName|| ''}`,
                        style: 'enunciado'
                    },
                ],
            } : null,

            {
                margin: [0,20,0,0],
                table: {
                    widths: ['43%', '57%'],
                    body: [
                        [
                            {
                                text: [
                                    {
                                        text: 'RTN: ',
                                        style: 'enunciado',
                                    },
                                    {
                                        text: `${infoEmpresa?.RTN || ''}`,
                                        style: 'enunciadoSimple',
                                    },
                                ],
                                border: [false, false, false, false]
                            },
                            {
                                text: [
                                    {
                                        text: 'Fecha Límite de Emisión: ',
                                        style: 'enunciadoRight',
                                    },
                                    {
                                        text: `${(encabezado?.FechaEmisionStr).toLocaleString()}`,
                                        style: 'enunciadoSimpleRight',
                                    },
                                ],
                                border: [false, false, false, false]
                            },
                        ],
                        [
                            {
                                text: [
                                    {
                                        text: 'CAI: ',
                                        style: 'enunciado',
                                    },
                                    {
                                        text: `${encabezado?.CAI || ''}`,
                                        style: 'enunciadoSimple',
                                    },
                                ],
                                border: [false, false, false, false]
                            },
                            {
                                 text: [
                                    {
                                        text: 'Rango Autorizado: ',
                                        style: 'enunciadoRight',
                                    },
                                    {
                                        text: `${encabezado?.RangoAutorizado || ''}`,
                                        style: 'enunciadoSimpleRight',
                                    },
                                ],
                                border: [false, false, false, true],
                                rowSpan: 2,
                            },
                        ],
                        [
                            {
                                text: [
                                    {
                                        text: 'Teléfono: ',
                                        style: 'enunciado',
                                    },
                                    {
                                        text: `${infoEmpresa?.Telefono || ''}`,
                                        style: 'enunciadoSimple',
                                    },
                                ],
                                border: [false, false, false, true]
                            },
                            {},
                        ],
                    ],
                },
                layout: tablaLayout,
            },
            {
                margin: [0,10,0,0],
                table: {
                    widths: ['19%', '30%', '29%', '22%'],
                    body: [
                        [
                            {
                                text: 'Nombre del Proveedor: ',
                                style: 'enunciado2',
                                border:[false, false, true,false]
                            },
                            {
                                text: `${encabezado.CustomerName || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, true, false, false]
                            },
                            {
                                text: 'Datos del Adquiriente Exónerado',
                                style: 'enunciado2',
                                alignment: 'center',
                                border:[false, true, false, false],
                                colSpan:2,
                            },
                            {},
                        ],
                        [
                            {
                                text: 'Identidad / RTN:',
                                style: 'enunciado2',
                                border:[false, false, true,false]
                            },
                            {
                                text: `${encabezado.RTN || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, false, false, false]
                            },
                            {
                                text: 'Orden de Compra Exenta:',
                                style: 'enunciado3',
                                border:[false, false, false, false]
                            },
                            {
                                text: `${encabezado.OrdenCompra || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, false, false, false]
                            },
                        ],
                        [
                            {
                                text: 'Teléfono:',
                                style: 'enunciado2',
                                border:[false, false, true,false]
                            },
                            {
                                text: `${encabezado.Telefono || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, false, false, false]
                            },
                            {
                                text: 'Constancia de Registro Exónerado:',
                                style: 'enunciado3',
                                border:[false, false, false, false]
                            },
                            {
                                text: `${encabezado.ConstanciaRegistro || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, false, false, false]
                            },
                        ],
                        [
                            {
                                text: 'Domicilio:',
                                style: 'enunciado2',
                                border:[false, false, true, true]
                            },
                            {
                                text: `${encabezado.Address || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, false, false, false]
                            },
                            {
                                text: 'Registro de la SAG:',
                                style: 'enunciado3',
                                border:[false, false, false, false]
                            },
                            {
                                text: `${encabezado.RegistroSAG || ''}`,
                                style: 'enunciadoSimple2',
                                border:[false, false, false, false]
                            },
                        ],
                    ]
                },
            },
            {
                margin: [0, 10, 0, 0],
                table: {
                    widths: ["30%", "*", "7%", "7%", "8%"],
                    body: [
                        [
                            {
                                text: "Producto",
                                style: "enunciadoTabla",
                            },
                            {
                                text: "Descripción",
                                style: "enunciadoTabla",
                            },
                            {
                                text: "Cantidad",
                                style: "enunciadoTabla",
                            },
                            {
                                text: "Precio",
                                style: "enunciadoTabla",
                            },
                            {
                                text: "Monto",
                                style: "enunciadoTabla",
                            },
                        ],
                        ...detalles.map((item) => [
                            {
                                text: item.CodigoNombre || "",
                                style: "detalleTabla",
                            },
                            {
                                text: item.Descripcion || "",
                                style: "detalleTabla",
                            },
                            {
                                text: formatNumberDecimal(item.Unidades) || "",
                                style: "detalleTablaRight",
                            },
                            {
                                text: `L ${formatNumberDecimal(item.PrecioL)}` || "",
                                style: "detalleTablaRight",
                            },
                            {
                                text: `L ${formatNumberDecimal(item.TotalL)}` || "",
                                style: "detalleTablaRight",
                            },
                        ]),
                        [
                            { text: '', colSpan: 3, style: 'enunciadoTabla'}, {}, {},
                            { text: 'TOTAL', style: "enunciadoTabla", alignment: 'right' },
                            { text: `L ${formatNumberDecimal(totalGeneral)}`, style: "detalleTablaRight", bold: true, fillColor: '#e8e7e7', },
                        ],
                    ],
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 0.5; // grosor horizontal
                    },
                    vLineWidth: function (i, node) {
                        return 0.5; // grosor vertical
                    },
                    hLineColor: function (i, node) {
                        return 'gray'; // color horizontal
                    },
                    vLineColor: function (i, node) {
                        return 'gray'; // color vertical
                    },
                },
            },
            {
                margin: [0,10,0,0],
                text: [
                    {
                        text: 'Original: ',
                        style: 'enunciado2'
                    },
                    {
                        text: 'Contabilidad',
                        style: 'enunciadoSimple2'
                    },
                ],
            },
            {
                margin: [0,4,0,0],
                text: [
                    {
                        text: 'Copia: ',
                        style: 'enunciado2'
                    },
                    {
                        text: 'Proveedor',
                        style: 'enunciadoSimple2'
                    },
                ],
            },
            {
                margin: [0,4,0,0],
                text: [
                    {
                        text: 'Nota: ',
                        style: 'enunciado2'
                    },
                    {
                        text: `${encabezado.Comentario|| ''}`,
                        style: 'enunciadoSimple2'
                    },
                ],
            },

            // FIRMAS
            {
                margin: [30,50,30,0],
                table: {
                    widths: ['45%', '10%', '45%'],
                    body: [
                        [
                            firmaCreate ?
                            {
                                image:  "data:image/png;base64," + firmaCreate,
                                width: 150,
                                height: 100,
                                border: [false,false,false,false],
                                margin: [30,0,0,0]
                            } :
                            {
                                image:  "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 100,
                                border: [false,false,false,false]
                            },
                            {
                                text: '',
                                border: [false, false, false, false]
                            },
                            firmaRecibe ?
                            {
                                image:  "data:image/png;base64," + firmaRecibe,
                                width: 150,
                                height: 100,
                                border: [false,false,false,false],
                                margin: [30,0,0,0],
                            } :
                            {
                                image:  "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 100,
                                border: [false,false,false,false]
                            },
                        ],
                        [
                            {
                                text: `Elaborado Por: \n${(encabezado?.UserNameCreo || '')}`,
                                style: `enunciadoCenter`,
                                border: [false, true, false, false]
                            },
                            {
                                text: '',
                                border: [false, false, false, false]
                            },
                            {
                                text: `Recibido Por: \n${(encabezado?.UserNameEdit || '')}`,
                                style: `enunciadoCenter`,
                                border: [false, true, false, false]
                            },
                        ],
                    ],
                },
            },
        ],

        styles: {
            titulo: {
              fontSize: 13,
              bold: true,
              alignment: "center",
            },
            titulo3: {
                fontSize: 11,
                alignment: "justify",
            },
            titulo4: {
                fontSize: 12,
                bold: true,
                alignment: "center",
            },
            titulo5: {
                fontSize: 11,
                alignment: "center",
                color: 'red',
                bold: true,
            },
            header: {
                fontSize: 9,
                alignment: "right",
            },
            enunciado: {
                fontSize: 10,
                bold: true,
                alignment: "justify",
            },
            enunciadoCenter: {
                fontSize: 10,
                bold: true,
                alignment: "center",
            },
            enunciadoRight: {
                fontSize: 10,
                bold: true,
                alignment: "right",
            },
            enunciadoSimpleRight: {
                fontSize: 10,
                alignment: "right",
            },
            enunciado2: {
                fontSize: 9,
                bold: true,
                alignment: "justify",
            },
            enunciado3: {
                fontSize: 9,
                bold: true,
                alignment: "right",
            },
            enunciadoSimple: {
                fontSize: 10,
                alignment: "left",
            },
            enunciadoSimple2: {
                fontSize: 9,
                alignment: "left",
            },
            enunciadoTabla: {
                fontSize: 8,
                bold: true,
                alignment: "center",
                fillColor: '#e8e7e7'
            },
            detalleTabla: {
                fontSize: 8,
                alignment: "justify",
            },
            detalleTablaRight: {
                fontSize: 8,
                alignment: "right",
            },
            detalleTablaCenter: {
                fontSize: 8,
                alignment: "center",
            },
            footer: {
                fontSize: 8,
                alignment: "justify",
            },
            footerPag: {
                fontSize: 8,
                alignment: "right",
            },
        },
    }

    const doc = pdfMake.createPdf(docDefinition);

    doc.getDataUrl((url) =>{ setFormato(url) })
    setLoading(false)
  }

  const onHide = () => {
    setShowDialogReporte(false);
    setSelected([])
  };

  useEffect(() => {
    if (showDialogReporte) {
      getValoresIniciales(selected);
    }
  }, [showDialogReporte]);

  return (
    <div>
      <Dialog
        visible={showDialogReporte}
        onHide={onHide}
        style={{ width: "63vw", height: "85vh" }}
      >
        <Loader loading={loading} querySelector='FormatoDialog' />
        <div id="FormatoDialog">
          {!loading && formato && (
            <iframe
              src={formato}
              style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
              id="foo"
            />
          )}
        </div>
      </Dialog>
      
    </div>
  );
};

export default BoletaCompraReporte;
